<script setup lang="ts">
import { Capacitor } from '@capacitor/core';
import { useLocalStorage } from '@vueuse/core';

const update = useNativeAppUpdate();
const dismissedVersion = useLocalStorage<string | null>('nativeUpdateDismissedVersion', null);
const storeUrl = Capacitor.getPlatform() === 'android' ? APP_STORE_URLS.android : APP_STORE_URLS.ios;

const showRecommended = computed({
  get: () => update.value.status === 'recommended' && dismissedVersion.value !== update.value.recommendedVersion,
  set: (open: boolean) => {
    if (!open) dismissedVersion.value = update.value.recommendedVersion;
  },
});
</script>

<template>
  <div
    v-if="update.status === 'required'"
    class="fixed inset-0 z-[1000] flex flex-col items-center justify-center gap-4 px-8 text-center bg-default"
    :style="{ paddingTop: 'env(safe-area-inset-top)', paddingBottom: 'env(safe-area-inset-bottom)' }"
  >
    <UIcon name="heroicons:arrow-down-tray" class="text-primary text-5xl" />
    <p class="text-lg font-semibold text-highlighted">{{ $t('nativeUpdate.required.title') }}</p>
    <p class="text-muted">{{ $t('nativeUpdate.required.description') }}</p>
    <UButton :label="$t('nativeUpdate.button')" icon="heroicons:arrow-top-right-on-square" size="lg" :to="storeUrl" target="_blank" external />
  </div>
  <UModal
    v-else
    v-model:open="showRecommended"
    :title="$t('nativeUpdate.recommended.title')"
    :description="$t('nativeUpdate.recommended.description')"
  >
    <template #footer>
      <div class="flex justify-end gap-2 w-full">
        <UButton :label="$t('nativeUpdate.later')" color="neutral" variant="ghost" @click="showRecommended = false" />
        <UButton :label="$t('nativeUpdate.button')" icon="heroicons:arrow-top-right-on-square" :to="storeUrl" target="_blank" external />
      </div>
    </template>
  </UModal>
</template>
